/* tslint:disable */
/* eslint-disable */
/**
 * Cetas Crow WebAPI
 * Cetas Crow Data Web Servis
 *
 * The version of the OpenAPI document: v1
 * Contact: support@rasyonet.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface CardField
 */
export interface CardField {
    /**
     * 
     * @type {string}
     * @memberof CardField
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CardField
     */
    'name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CardField
     */
    'order'?: number;
    /**
     * 
     * @type {number}
     * @memberof CardField
     */
    'value'?: number;
    /**
     * 
     * @type {string}
     * @memberof CardField
     */
    'textValue'?: string | null;
}
/**
 * 
 * @export
 * @interface MailLog
 */
export interface MailLog {
    /**
     * 
     * @type {string}
     * @memberof MailLog
     */
    'sender'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MailLog
     */
    'status'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MailLog
     */
    'date'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof MailLog
     */
    'toEmails'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface NewsDetail
 */
export interface NewsDetail {
    /**
     * 
     * @type {string}
     * @memberof NewsDetail
     */
    'body'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NewsDetail
     */
    'id'?: string | null;
}
/**
 * 
 * @export
 * @interface NewsRow
 */
export interface NewsRow {
    /**
     * 
     * @type {string}
     * @memberof NewsRow
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NewsRow
     */
    'date'?: string;
    /**
     * 
     * @type {string}
     * @memberof NewsRow
     */
    'header'?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const PriceChartPeriod = {
    OneWeek: 'OneWeek',
    OneMonth: 'OneMonth',
    ThreeMonth: 'ThreeMonth',
    SixMonth: 'SixMonth',
    OneYear: 'OneYear',
    TwoYear: 'TwoYear',
    ThreeYear: 'ThreeYear',
    FiveYear: 'FiveYear'
} as const;

export type PriceChartPeriod = typeof PriceChartPeriod[keyof typeof PriceChartPeriod];


/**
 * 
 * @export
 * @enum {string}
 */

export const SecurityList = {
    Cates: 'CATES'
} as const;

export type SecurityList = typeof SecurityList[keyof typeof SecurityList];



/**
 * SnaphotApi - axios parameter creator
 * @export
 */
export const SnaphotApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [symbolEntityId] 
         * @param {string} [cultureCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSnaphotCardFieldsGet: async (symbolEntityId?: string, cultureCode?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/snaphot/card-fields`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basic required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (symbolEntityId !== undefined) {
                localVarQueryParameter['symbolEntityId'] = symbolEntityId;
            }

            if (cultureCode !== undefined) {
                localVarQueryParameter['cultureCode'] = cultureCode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSnaphotMailLogGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/snaphot/mail-log`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basic required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [newsId] 
         * @param {string} [cultureCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSnaphotNewsDetailGet: async (newsId?: number, cultureCode?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/snaphot/news-detail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basic required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (newsId !== undefined) {
                localVarQueryParameter['newsId'] = newsId;
            }

            if (cultureCode !== undefined) {
                localVarQueryParameter['cultureCode'] = cultureCode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [cultureCode] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [firsDate] 
         * @param {string} [lastDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSnaphotNewsGet: async (cultureCode?: string, limit?: number, offset?: number, firsDate?: string, lastDate?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/snaphot/news`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basic required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (cultureCode !== undefined) {
                localVarQueryParameter['cultureCode'] = cultureCode;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (firsDate !== undefined) {
                localVarQueryParameter['firsDate'] = (firsDate as any instanceof Date) ?
                    (firsDate as any).toISOString() :
                    firsDate;
            }

            if (lastDate !== undefined) {
                localVarQueryParameter['lastDate'] = (lastDate as any instanceof Date) ?
                    (lastDate as any).toISOString() :
                    lastDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<SecurityList>} [symbolEntityId] 
         * @param {PriceChartPeriod} [period] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSnaphotPriceChartGet: async (symbolEntityId?: Array<SecurityList>, period?: PriceChartPeriod, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/snaphot/price-chart`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basic required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (symbolEntityId) {
                localVarQueryParameter['symbolEntityId'] = symbolEntityId;
            }

            if (period !== undefined) {
                localVarQueryParameter['period'] = period;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SnaphotApi - functional programming interface
 * @export
 */
export const SnaphotApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SnaphotApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [symbolEntityId] 
         * @param {string} [cultureCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSnaphotCardFieldsGet(symbolEntityId?: string, cultureCode?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CardField>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSnaphotCardFieldsGet(symbolEntityId, cultureCode, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSnaphotMailLogGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MailLog>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSnaphotMailLogGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [newsId] 
         * @param {string} [cultureCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSnaphotNewsDetailGet(newsId?: number, cultureCode?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<NewsDetail>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSnaphotNewsDetailGet(newsId, cultureCode, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [cultureCode] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [firsDate] 
         * @param {string} [lastDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSnaphotNewsGet(cultureCode?: string, limit?: number, offset?: number, firsDate?: string, lastDate?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<NewsRow>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSnaphotNewsGet(cultureCode, limit, offset, firsDate, lastDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<SecurityList>} [symbolEntityId] 
         * @param {PriceChartPeriod} [period] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSnaphotPriceChartGet(symbolEntityId?: Array<SecurityList>, period?: PriceChartPeriod, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<{ [key: string]: Array<any>; }>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSnaphotPriceChartGet(symbolEntityId, period, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SnaphotApi - factory interface
 * @export
 */
export const SnaphotApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SnaphotApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [symbolEntityId] 
         * @param {string} [cultureCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSnaphotCardFieldsGet(symbolEntityId?: string, cultureCode?: string, options?: any): AxiosPromise<Array<CardField>> {
            return localVarFp.apiSnaphotCardFieldsGet(symbolEntityId, cultureCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSnaphotMailLogGet(options?: any): AxiosPromise<Array<MailLog>> {
            return localVarFp.apiSnaphotMailLogGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [newsId] 
         * @param {string} [cultureCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSnaphotNewsDetailGet(newsId?: number, cultureCode?: string, options?: any): AxiosPromise<Array<NewsDetail>> {
            return localVarFp.apiSnaphotNewsDetailGet(newsId, cultureCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [cultureCode] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [firsDate] 
         * @param {string} [lastDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSnaphotNewsGet(cultureCode?: string, limit?: number, offset?: number, firsDate?: string, lastDate?: string, options?: any): AxiosPromise<Array<NewsRow>> {
            return localVarFp.apiSnaphotNewsGet(cultureCode, limit, offset, firsDate, lastDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<SecurityList>} [symbolEntityId] 
         * @param {PriceChartPeriod} [period] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSnaphotPriceChartGet(symbolEntityId?: Array<SecurityList>, period?: PriceChartPeriod, options?: any): AxiosPromise<Array<{ [key: string]: Array<any>; }>> {
            return localVarFp.apiSnaphotPriceChartGet(symbolEntityId, period, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SnaphotApi - object-oriented interface
 * @export
 * @class SnaphotApi
 * @extends {BaseAPI}
 */
export class SnaphotApi extends BaseAPI {
    /**
     * 
     * @param {string} [symbolEntityId] 
     * @param {string} [cultureCode] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SnaphotApi
     */
    public apiSnaphotCardFieldsGet(symbolEntityId?: string, cultureCode?: string, options?: AxiosRequestConfig) {
        return SnaphotApiFp(this.configuration).apiSnaphotCardFieldsGet(symbolEntityId, cultureCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SnaphotApi
     */
    public apiSnaphotMailLogGet(options?: AxiosRequestConfig) {
        return SnaphotApiFp(this.configuration).apiSnaphotMailLogGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [newsId] 
     * @param {string} [cultureCode] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SnaphotApi
     */
    public apiSnaphotNewsDetailGet(newsId?: number, cultureCode?: string, options?: AxiosRequestConfig) {
        return SnaphotApiFp(this.configuration).apiSnaphotNewsDetailGet(newsId, cultureCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [cultureCode] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {string} [firsDate] 
     * @param {string} [lastDate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SnaphotApi
     */
    public apiSnaphotNewsGet(cultureCode?: string, limit?: number, offset?: number, firsDate?: string, lastDate?: string, options?: AxiosRequestConfig) {
        return SnaphotApiFp(this.configuration).apiSnaphotNewsGet(cultureCode, limit, offset, firsDate, lastDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<SecurityList>} [symbolEntityId] 
     * @param {PriceChartPeriod} [period] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SnaphotApi
     */
    public apiSnaphotPriceChartGet(symbolEntityId?: Array<SecurityList>, period?: PriceChartPeriod, options?: AxiosRequestConfig) {
        return SnaphotApiFp(this.configuration).apiSnaphotPriceChartGet(symbolEntityId, period, options).then((request) => request(this.axios, this.basePath));
    }
}



